import { ApiUrl } from "../../../Constants/Api";
import {
  REQUEST_METHOD,
  WebService,
} from "../../WebServiceManager/RequestService";
import TimeOffRequestBody from "./TimeOffRequestBody";

export default class TimeOffService {
  request = new TimeOffRequestBody();
  static shared = new TimeOffService();

  requestTimeOff = (payload) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.requestTimeOff(),
          this.request.requestTimeOffRequest(payload, REQUEST_METHOD.POST)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  getTimeOffRequests = (params) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.getTimeOffRequests(params.page, params.size, params.status, params.sort, params.startDate, params.endDate),
          this.request.getTimeOffRequestsRequest(REQUEST_METHOD.GET)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  getAllTimeOffWithoutPagination = () => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.getAllTimeOffWithoutPagination(),
          this.request.getAllTimeOffWithoutPaginationRequest(REQUEST_METHOD.GET)
        )   
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  getTimeOffById = (params) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.getTimeOffById(params.id),
          this.request.getTimeOffByIdRequest(REQUEST_METHOD.GET)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  updateTimeOff = (params) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.updateTimeOff(params.id),
          this.request.updateTimeOffRequest(params.data, REQUEST_METHOD.PUT)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  cancelTimeOff = (params) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.cancelTimeOff(params.id),
          this.request.cancelTimeOffRequest(REQUEST_METHOD.PUT)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
}


